const ACTION_SEQUENCE_ACTIONS = {
  ACTION_SEQUENCE_STARTED: 'ACTION_SEQUENCE_STARTED',
  ACTION_SEQUENCE_FINISHED: 'ACTION_SEQUENCE_FINISHED'
};

const actionSequenceFinishedAction = ({ results }) => {
  return {
    type: ACTION_SEQUENCE_ACTIONS.ACTION_SEQUENCE_FINISHED,
    payload: { results }
  };
};

const actionSequenceStartedAction = ({ actionSequence }) => {
  return {
    type: ACTION_SEQUENCE_ACTIONS.ACTION_SEQUENCE_STARTED,
    payload: { actionSequence }
  };
};

export {
  ACTION_SEQUENCE_ACTIONS,
  actionSequenceStartedAction,
  actionSequenceFinishedAction
};
